"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MovieIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.77 6.41V4.178A1.93 1.93 0 009.842 2.25H2.178A1.93 1.93 0 00.25 4.178v7.664a1.93 1.93 0 001.928 1.928h7.664a1.93 1.93 0 001.928-1.928V9.61l2.372 1.976c.807.673 1.468.365 1.468-.696V5.13c0-1.068-.657-1.372-1.468-.696L11.77 6.41z"
  })))
});
MovieIcon.displayName = 'MovieIcon';
var _default = exports.default = MovieIcon;